import type { TourDefinition } from '../tours.types';

export const MODAL_AGREGAR_CERTIFICADO_BUSQUEDA_TOUR: TourDefinition = {
  id: 'modal_agregar_certificado_busqueda_help',
  remember: true,
  steps: [
    {
      element: '[data-tour="busqueda-certificado"]',
      popover: {
        title: 'Búsqueda de usuario',
        description:
          'Aquí puedes buscar un usuario dentro de la aplicación, ya sea por su nombre o por su correo electrónico.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="toggle-firmar-con-imagen"]',
      popover: {
        title: 'Firmar con imagen',
        description:
          'Esta opción te permite utilizar una imagen como firma. Al activarla, se reemplaza el diseño predeterminado de la firma electrónica por una imagen previamente configurada para tu usuario.',
        side: 'bottom',
        align: 'center',
      },
    },
  ],
};
